export function waitForTime(timeout: number) {
  return new Promise((resolve) => setTimeout(resolve, timeout));
}
